import { create } from 'zustand'
import { devtools } from 'zustand/middleware'


interface T_HelpStore {
  isAtLeastOneUnreadMessage: boolean
  setIsAtLeastOneUnreadMessage: (isAtLeastOneUnreadMessage: boolean) => void
}

export const useHelpStore = create<T_HelpStore>()(
  devtools(
    (set) => ({
      isAtLeastOneUnreadMessage: false,

      setIsAtLeastOneUnreadMessage: (isAtLeastOneUnreadMessage) => set(
        () => ({ isAtLeastOneUnreadMessage }),
        false,
        'setIsAtLeastOneUnreadMessage',
      ),
    }),

    { store: 'Help' },
  )
)
